import { onMounted, onUnmounted, ref } from 'vue'

export function usePlaySound() {
  const isPlaying = ref(false)
  const audioElement = ref<HTMLAudioElement>()

  const handleAudio = (state: 'play' | 'pause') => {
    audioElement.value?.[state]()
  }

  const toggleSound = () => {
    isPlaying.value ? handleAudio('pause') : handleAudio('play')
    isPlaying.value = !isPlaying.value
  }

  onMounted(() => {
    if (audioElement.value) audioElement.value.onended = () => isPlaying.value = false
  })

  onUnmounted(() => {
    if (audioElement.value) audioElement.value.onended = null
  })

  return {
    isPlaying,
    toggleSound,
    audioElement
  }

}